import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Header, Button } from 'semantic-ui-react';
import i18next from 'i18next';
import { resetState } from '../../actions';

const DeadlineAlert = () => {
    const dispatch = useDispatch();
    const deadline = useSelector(state => state.order.cartDeadline);
    const timeToDeadline = new Date(deadline) - new Date();
    const [, forceUpdate] = useState();

    useEffect(() => {
        let timeout;

        if (timeToDeadline > 0) {
            timeout = setTimeout(() => {
                forceUpdate({});
            }, timeToDeadline);
        }

        return () => clearTimeout(timeout);
    }, [timeToDeadline]);

    const handleConfirmReset = () => {
        dispatch(resetState());
    };

    return (
        <Modal open={deadline && timeToDeadline < 0} basic size='small'>
            <Header icon='warning circle' content={i18next.t('order.deadlineReached')} />
            <Modal.Actions className="pi actions">
                <Button inverted onClick={handleConfirmReset}>
                    {i18next.t('general.ok')}
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

DeadlineAlert.propTypes = {
    message: PropTypes.string
};

export default DeadlineAlert;
